import { useState, useEffect, createElement } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

// In production, use environment variables
const ADMIN_CONFIG = { password: 'S1nka1' }

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const checkAuth = () => {
      const session = localStorage.getItem('sinka_admin_session')
      if (session) {
        try {
          const data = JSON.parse(session)
          const isExpired = Date.now() - data.timestamp > 24 * 60 * 60 * 1000
          if (!isExpired && data.authenticated) {
            setIsAuthenticated(true)
          } else {
            localStorage.removeItem('sinka_admin_session')
            setIsAuthenticated(false)
          }
        } catch (e) {
          setIsAuthenticated(false)
        }
      }
      setIsLoading(false)
    }
    checkAuth()
  }, [])

  const login = (password: string): boolean => {
    if (password === ADMIN_CONFIG.password) {
      localStorage.setItem(
        'sinka_admin_session',
        JSON.stringify({ authenticated: true, timestamp: Date.now() }),
      )
      setIsAuthenticated(true)
      return true
    }
    return false
  }

  const logout = () => {
    localStorage.removeItem('sinka_admin_session')
    setIsAuthenticated(false)
  }

  return { isAuthenticated, isLoading, login, logout }
}

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return createElement(
      'div',
      {
        className:
          'min-h-screen bg-background flex items-center justify-center font-mono text-sm text-muted-foreground',
      },
      'Checking authentication...',
    )
  }

  if (!isAuthenticated) {
    return createElement(Navigate, {
      to: '/admin/login',
      state: { from: location },
      replace: true,
    })
  }

  return createElement('div', null, children)
}
